var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"f-row full app-wrapper"},[_c('Side'),_c('div',{staticClass:"f-col full"},[_c('Header'),_c('Body'),_c('Footer')],1),(_vm.displayModal)?_c('Modal'):_vm._e(),_c('Notification')],1)}
var staticRenderFns = []

export { render, staticRenderFns }